import _forOwn from "./forOwn";
import _isPlainObject from "../lang/isPlainObject";

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};
var forOwn = _forOwn;
var isPlainObject = _isPlainObject;
/**
 * Mixes objects into the target object, recursively mixing existing child
 * objects.
 */

function deepMixIn(target, objects) {
  var i = 0,
      n = arguments.length,
      obj;

  while (++i < n) {
    obj = arguments[i];

    if (obj) {
      forOwn(obj, copyProp, target);
    }
  }

  return target;
}

function copyProp(val, key) {
  var existing = (this || _global)[key];

  if (isPlainObject(val) && isPlainObject(existing)) {
    deepMixIn(existing, val);
  } else {
    (this || _global)[key] = val;
  }
}

exports = deepMixIn;
export default exports;